import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "about-us" }
const _hoisted_2 = { class: "job-details" }
const _hoisted_3 = ["onClick"]
const _hoisted_4 = { class: "text-title" }

import { ref, onMounted } from 'vue'
import { selectCommonElement } from '@/api'
import { useRouter } from 'vue-router';
import { useStore } from 'vuex'
import BannerC from '@/components/BannerC.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AboutUsDetail',
  setup(__props) {

const store = useStore()
const jobDetails: any = ref([])
const router = useRouter()

const toOtherPath = (url: string, pageTitle: any) => {
  router.push(url);
  store.state.pageTitle = [...pageTitle]
}

onMounted(() => {
  selectCommonElement({ columnId: 7 }).then((res: any) => {
    jobDetails.value = [...res].sort((a: any, b: any) => (a.sortNum ?? 0) - (b.sortNum ?? 0))
  })
  if (document.documentElement && document.documentElement.scrollTop) {
    document.documentElement.scrollTop = 0;
  } else if (document.body) {
    document.body.scrollTop = 0
  }
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(BannerC),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", null, [
        _cache[0] || (_cache[0] = _createElementVNode("div", { class: "title" }, "加入我们", -1)),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(jobDetails.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              onClick: ($event: any) => (toOtherPath(`/job_detail?id=${item.id}&pathName=关于我们,加入我们,岗位详情`, ['关于我们', '加入我们', '岗位详情']))
            }, [
              _createElementVNode("div", _hoisted_4, _toDisplayString(item.name), 1),
              _createElementVNode("div", null, _toDisplayString(item.introduction), 1)
            ], 8, _hoisted_3))
          }), 128))
        ])
      ])
    ])
  ]))
}
}

})